<div role="alert" aria-live="polite" aria-atomic="true" class="wrapper" [class.visible]="visible()">
    <div class="content">
        @for (error of displayedErrors() | keyvalue; track error.key + (error.value ?? '')) {
            <span class="error">{{ error | error }}</span>
        }
    </div>
</div>
